//src/app/features/taxExtensions/useTaxExtension.tsx
import { useGetTaxExtensionByIdQuery } from 'app/services/taxExtensions';
import { useParams } from 'react-router-dom';

export default function useTaxExtension() {
  const { taxExtensionId } = useParams();

  return useGetTaxExtensionByIdQuery(+taxExtensionId!, {
    skip: !taxExtensionId,
  });
}
